import { ContentItem } from '../types'
import { Text } from '@crossfit/design-system'
import style from './style.module.scss'
import { Button, Icon } from '@crossfit/ui'
import { trackEvent } from 'services/segment'
import { useSelector } from 'react-redux'
import { getMyAffiliates } from 'store/selectors'

export default function ContentCard({ item }: { item: ContentItem }) {
  const { selectedAffiliate } = useSelector(getMyAffiliates)
  return (
    <a
      href={item.link?.url}
      target='_blank'
      className={style.link}
      rel='noreferrer'
      onClick={() => {
        trackEvent({
          component: 'atk-marketing-content',
          event: 'Button Clicked',
          text: item.link?.text,
          linkUrl: item.link?.url,
          affiliateId: selectedAffiliate?.affiliateId,
          userRole:
            selectedAffiliate?.roles?.length > 0
              ? selectedAffiliate?.roles[0]
              : null,
          groupId: selectedAffiliate?.groupId,
          tileName: item.headlineText,
        })
      }}
    >
      <div className={style.container}>
        <div className={style.left}>
          <div className={style.headerContainer}>
            <Text type='body' size='md' bold className={style.headline}>
              {item.headlineText}
            </Text>
            <Text type='body' size='sm' className={style.bodyText}>
              {item.bodyText}
            </Text>
          </div>
          <Button rightIcon={<Icon name='arrow-right' />} variant='tertiary'>
            {item.link?.text}
          </Button>
        </div>
        <div className={style.right}>
          <img src={item.image?.sizes?.thumbnail} className={style.image} />
        </div>
      </div>
    </a>
  )
}
